const SIGN_REQUESTS = {
    commercialContract: 'commercial_contract'
};
export default SIGN_REQUESTS;
